<div class="ui-level2-page-wrapper h-100">
  <div class="ui-level2-page h-100 flex-col min-h-0 alarms-management-root">
    <div class="page-header flex-row space-between-center">
      <div class="page-header-start flex-row start-center gap-16 flex-wrap">
        <div class="page-title">{{ 'ALARMS_MANAGEMENT.TITLE' | translate }}</div>
        <div class="alarms-status" *ngIf="(activeAlarmsCount$ | async) as count">
          <span class="status-dot" [class.has-alarms]="count > 0"></span>
          <span class="status-text">
            <ng-container *ngIf="count > 0; else noActiveStatus">
              {{ 'ALARMS_MANAGEMENT.STATUS_ACTIVE_ALARMS' | translate: { count: count } }}
            </ng-container>
            <ng-template #noActiveStatus>{{ 'ALARMS_MANAGEMENT.STATUS_NO_ACTIVE_ALARMS' | translate }}</ng-template>
          </span>
        </div>
      </div>
      <ui-button
        type="secondary"
        [matTooltip]="'ALARMS_MANAGEMENT.REFRESH' | translate"
        matTooltipClass="sidebar-tooltip"
        (clickAction)="refresh()"
      >
        {{ 'ALARMS_MANAGEMENT.REFRESH' | translate }}
      </ui-button>
    </div>

    <!-- Tab Navigation -->
    <mat-tab-group (selectedIndexChange)="onTabChange($event)" class="alarms-tabs">
    <!-- Active Alarms Tab -->
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-label">
          {{ 'ALARMS_MANAGEMENT.ACTIVE_ALARMS' | translate }}
          <span class="tab-badge active-badge" *ngIf="(activeAlarmsCount$ | async) as count">{{ count }}</span>
        </span>
      </ng-template>

      <div class="tab-content">
        <ng-container *ngIf="(alarmsWithAlerts$ | async) as alarmsList">
          <div class="table-scroll-container" *ngIf="alarmsList?.length > 0; else noActiveAlarmsContent">
            <!-- Alarms Table with Expandable Rows -->
            <div class="alarms-list">
              <div *ngFor="let alarm of alarmsList; trackBy: trackByAlarmId" class="alarm-item">
                <!-- Alarm Row -->
                <div class="alarm-row" [class.expanded]="(isAlarmExpanded$(alarm.id) | async)">
                  <div class="expand-toggle" (click)="toggleAlarmExpansion(alarm.id)">
                    <mat-icon>{{ (isAlarmExpanded$(alarm.id) | async) ? 'expand_more' : 'chevron_right' }}</mat-icon>
                  </div>
                  <div class="alarm-id">{{ alarm.id }}</div>
                  <div class="alarm-location">{{ locationName$(alarm.locationId) | async }}</div>
                  <div class="alarm-alerts-count">
                    <span class="alerts-badge" [class.has-alerts]="alarm.alertInstancesCount > 0">
                      {{ alarm.alertInstancesCount }} {{ alarm.alertInstancesCount === 1 ? 'Alert' : 'Alerts' }}
                    </span>
                  </div>
                  <div class="alarm-dispatch-time">
                    <ui-user-settings-date [date]="alarm.dispatchTime" [timezone]="alarm.timezone" [dateTypeFormat]="UiUserSettingsDateType.mdyTimeSec"></ui-user-settings-date>
                  </div>
                  <div class="alarm-status">
                    <span class="status-badge" [class]="getStatusClass(alarm.status)">
                      {{ getStatusText(alarm.status) }}
                    </span>
                  </div>
                  <div class="alarm-actions" *ngIf="alarm.status === AlarmStatus.ACTIVE">
                    <ui-button type="primary" (clickAction)="cancelAlarmById(alarm.id)">
                      {{ 'ALARMS_MANAGEMENT.CANCEL_ALARM' | translate }}
                    </ui-button>
                  </div>
                </div>

                <!-- Expanded Detail Panel -->
                <div class="alarm-detail-panel" *ngIf="(isAlarmExpanded$(alarm.id) | async)">
                  <div class="detail-panel-content">
                    <h6 class="panel-title">Alert Instances</h6>

                    <ng-container *ngIf="!(alertInstancesLoading$(alarm.id) | async); else loadingAlertInstances">
                      <ng-container *ngIf="(alertInstances$(alarm.id) | async) as alertInstances">
                        <div class="alert-instances-list" *ngIf="alertInstances.length > 0; else noAlertInstances">
                          <div *ngFor="let alert of alertInstances; trackBy: trackByAlertInstanceId" class="alert-instance-item">
                            <div class="alert-instance-row">
                              <ng-container *ngIf="alert.mainThumbnail as thumbPath">
                                <div class="alert-thumbnail" *ngIf="!isAlertThumbFailed(alert.alertInstanceId)">
                                  <img
                                    [appAuthSrc]="getThumbUrl(thumbPath)"
                                    (authError)="onAlertThumbError(alert.alertInstanceId)"
                                    (click)="openImagePreview(thumbPath, $event)"
                                    alt=""
                                  />
                                </div>
                                <div class="alert-thumbnail thumb-placeholder" *ngIf="isAlertThumbFailed(alert.alertInstanceId)">
                                  <mat-icon aria-hidden="true">hide_image</mat-icon>
                                </div>
                              </ng-container>
                              <div class="alert-thumbnail thumb-placeholder" *ngIf="!alert.mainThumbnail">
                                <mat-icon aria-hidden="true">hide_image</mat-icon>
                              </div>
                              <div class="alert-info">
                                <div class="alert-id">Alert #{{ alert.alertInstanceId }}</div>
                                <div class="alert-camera">{{ cameraName$(alert.cameraId) | async }}</div>
                                <div class="alert-time">
                                  <ui-user-settings-date [date]="alert.timestamp" [timezone]="alert.timezone" [dateTypeFormat]="UiUserSettingsDateType.mdyTimeSec"></ui-user-settings-date>
                                </div>
                              </div>
                              <div class="alert-actions">
                                <ui-button type="default" icon="history" (clickAction)="openAlertDetailsDialog(alert)">
                                  {{ 'ALARMS_MANAGEMENT.NOONLIGHT_ACTIVITY' | translate }}
                                </ui-button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>

                    <ng-template #loadingAlertInstances>
                      <div class="loading-instances">
                        <ui-preloader [color]="loaderColor.blue"></ui-preloader>
                        <span>Loading alert instances...</span>
                      </div>
                    </ng-template>

                    <ng-template #noAlertInstances>
                      <div class="no-instances">
                        <mat-icon>info</mat-icon>
                        <span>No alert instances found for this alarm</span>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </mat-tab>

    <!-- Handled Alarms Tab -->
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-label">
          {{ 'ALARMS_MANAGEMENT.CANCELED_ALARMS' | translate }}
        </span>
      </ng-template>

      <div class="tab-content">
        <ng-container *ngIf="(alarmsWithAlerts$ | async) as alarmsList">
          <div class="table-scroll-container" *ngIf="alarmsList?.length > 0; else noCanceledAlarmsContent">
            <div class="alarms-list">
              <div *ngFor="let alarm of alarmsList; trackBy: trackByAlarmId" class="alarm-item">
                <!-- Alarm Row -->
                <div class="alarm-row" [class.expanded]="(isAlarmExpanded$(alarm.id) | async)">
                  <div class="expand-toggle" (click)="toggleAlarmExpansion(alarm.id)">
                    <mat-icon>{{ (isAlarmExpanded$(alarm.id) | async) ? 'expand_more' : 'chevron_right' }}</mat-icon>
                  </div>
                  <div class="alarm-id">{{ alarm.id }}</div>
                  <div class="alarm-location">{{ locationName$(alarm.locationId) | async }}</div>
                  <div class="alarm-alerts-count">
                    <span class="alerts-badge" [class.has-alerts]="alarm.alertInstancesCount > 0">
                      {{ alarm.alertInstancesCount }} {{ alarm.alertInstancesCount === 1 ? 'Alert' : 'Alerts' }}
                    </span>
                  </div>
                  <div class="alarm-dispatch-time">
                    <ui-user-settings-date [date]="alarm.dispatchTime" [timezone]="alarm.timezone" [dateTypeFormat]="UiUserSettingsDateType.mdyTimeSec"></ui-user-settings-date>
                  </div>
                  <div class="alarm-cancel-time" *ngIf="alarm.cancelTime">
                    <ui-user-settings-date [date]="alarm.cancelTime" [timezone]="alarm.timezone" [dateTypeFormat]="UiUserSettingsDateType.mdyTimeSec"></ui-user-settings-date>
                  </div>
                  <div class="alarm-duration">{{ getTimeDuration(alarm.dispatchTime, alarm.cancelTime) }}</div>
                  <div class="alarm-canceled-by">{{ alarm.cancelBy || 'Unknown' }}</div>
                  <div class="alarm-status">
                    <span class="status-badge" [class]="getStatusClass(alarm.status)">
                      {{ getStatusText(alarm.status) }}
                    </span>
                  </div>
                </div>

                <!-- Expanded Detail Panel (same as active) -->
                <div class="alarm-detail-panel" *ngIf="(isAlarmExpanded$(alarm.id) | async)">
                  <div class="detail-panel-content">
                    <h6 class="panel-title">Alert Instances</h6>

                    <ng-container *ngIf="!(alertInstancesLoading$(alarm.id) | async); else loadingAlertInstances2">
                      <ng-container *ngIf="(alertInstances$(alarm.id) | async) as alertInstances">
                        <div class="alert-instances-list" *ngIf="alertInstances.length > 0; else noAlertInstances2">
                          <div *ngFor="let alert of alertInstances; trackBy: trackByAlertInstanceId" class="alert-instance-item">
                            <div class="alert-instance-row">
                              <ng-container *ngIf="alert.mainThumbnail as thumbPath">
                                <div class="alert-thumbnail" *ngIf="!isAlertThumbFailed(alert.alertInstanceId)">
                                  <img
                                    [appAuthSrc]="getThumbUrl(thumbPath)"
                                    (authError)="onAlertThumbError(alert.alertInstanceId)"
                                    (click)="openImagePreview(thumbPath, $event)"
                                    alt=""
                                  />
                                </div>
                                <div class="alert-thumbnail thumb-placeholder" *ngIf="isAlertThumbFailed(alert.alertInstanceId)">
                                  <mat-icon aria-hidden="true">hide_image</mat-icon>
                                </div>
                              </ng-container>
                              <div class="alert-thumbnail thumb-placeholder" *ngIf="!alert.mainThumbnail">
                                <mat-icon aria-hidden="true">hide_image</mat-icon>
                              </div>
                              <div class="alert-info">
                                <div class="alert-id">Alert #{{ alert.alertInstanceId }}</div>
                                <div class="alert-camera">{{ cameraName$(alert.cameraId) | async }}</div>
                                <div class="alert-time">
                                  <ui-user-settings-date [date]="alert.timestamp" [timezone]="alert.timezone" [dateTypeFormat]="UiUserSettingsDateType.mdyTimeSec"></ui-user-settings-date>
                                </div>
                              </div>
                              <div class="alert-actions">
                                <ui-button type="default" icon="history" (clickAction)="openAlertDetailsDialog(alert)">
                                  {{ 'ALARMS_MANAGEMENT.NOONLIGHT_ACTIVITY' | translate }}
                                </ui-button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>

                    <ng-template #loadingAlertInstances2>
                      <div class="loading-instances">
                        <ui-preloader [color]="loaderColor.blue"></ui-preloader>
                        <span>Loading alert instances...</span>
                      </div>
                    </ng-template>

                    <ng-template #noAlertInstances2>
                      <div class="no-instances">
                        <mat-icon>info</mat-icon>
                        <span>No alert instances found for this alarm</span>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </mat-tab>

    <!-- Rejected Alerts Tab -->
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-label">
          {{ 'ALARMS_MANAGEMENT.REJECTED_ALERTS' | translate }}
          <span class="tab-badge rejected-badge" *ngIf="(rejectedAlertsTotal$ | async) as count">{{ count }}</span>
        </span>
      </ng-template>

      <div class="tab-content">
        <!-- Loading indicator -->
        <div class="loading-overlay" *ngIf="rejectedAlertsLoading$ | async">
          <ui-preloader [color]="loaderColor.blue"></ui-preloader>
        </div>

        <ng-container *ngIf="(rejectedAlerts$ | async) as rejectedList">
          <div class="rejected-alerts-container" *ngIf="rejectedList?.length > 0; else noRejectedAlertsContent">
            <div class="rejected-alerts-grid">
              <div *ngFor="let alert of rejectedList" class="rejected-alert-card" (click)="onRejectedAlertClick(alert)">
                <div class="thumbnail-container">
                  <img
                    *ngIf="alert.mainThumbnail && !isRejectedThumbFailed(alert.alertInstanceId)"
                    [appAuthSrc]="getThumbUrl(alert.mainThumbnail)"
                    (authError)="onRejectedThumbError(alert.alertInstanceId)"
                    (click)="openImagePreview(alert.mainThumbnail, $event)"
                    alt=""
                    class="alert-thumbnail"
                  />
                  <div
                    *ngIf="!alert.mainThumbnail || isRejectedThumbFailed(alert.alertInstanceId)"
                    class="no-thumbnail"
                    aria-hidden="true"
                  >
                    <mat-icon>hide_image</mat-icon>
                  </div>
                  <div class="thumbnail-overlay">
                    <span class="alert-message">{{ alert.alertMessage || 'No message' }}</span>
                  </div>
                </div>
                <div class="alert-details">
                  <div class="detail-row">
                    <mat-icon class="detail-icon">location_on</mat-icon>
                    <span class="detail-text">{{ alert.locationName || alert.locationId }}</span>
                  </div>
                  <div class="detail-row">
                    <mat-icon class="detail-icon">videocam</mat-icon>
                    <span class="detail-text">{{ alert.cameraName || alert.cameraId }}</span>
                  </div>
                  <div class="detail-row">
                    <mat-icon class="detail-icon">schedule</mat-icon>
                    <span class="detail-text">
                      <ui-user-settings-date [date]="alert.timestamp" [timezone]="alert.timezone" [dateTypeFormat]="UiUserSettingsDateType.mdyTimeSec"></ui-user-settings-date>
                    </span>
                  </div>
                  <div class="detail-row alert-id-row">
                    <span class="alert-id-label">ID:</span>
                    <span class="alert-id-value">{{ alert.alertInstanceId }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Paginator -->
            <ng-container *ngIf="(rejectedAlertsPagination$ | async) as pagination">
              <mat-paginator
                [length]="pagination.total"
                [pageSize]="pagination.limit"
                [pageIndex]="pagination.pageIndex"
                [pageSizeOptions]="[25, 50, 100]"
                (page)="onRejectedAlertsPageChange($event)"
                showFirstLastButtons>
              </mat-paginator>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </mat-tab>
    </mat-tab-group>
  </div>
</div>

<!-- No Content Templates -->
<ng-template #noActiveAlarmsContent>
  <div class="no-content">
    <mat-icon>check_circle</mat-icon>
    <p>{{ 'ALARMS_MANAGEMENT.NO_ACTIVE_ALARMS_DESC' | translate }}</p>
  </div>
</ng-template>

<ng-template #noCanceledAlarmsContent>
  <div class="no-content">
    <mat-icon>history</mat-icon>
    <h6>{{ 'ALARMS_MANAGEMENT.NO_CANCELED_ALARMS' | translate }}</h6>
    <p>{{ 'ALARMS_MANAGEMENT.NO_CANCELED_ALARMS_DESC' | translate }}</p>
  </div>
</ng-template>

<ng-template #noRejectedAlertsContent>
  <div class="no-content">
    <mat-icon>block</mat-icon>
    <p>{{ 'ALARMS_MANAGEMENT.NO_REJECTED_ALERTS_DESC' | translate }}</p>
  </div>
</ng-template>
